import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import Text from '@liveauctioneers/caterwaul-components/lib/Text/Text';

type Props = {
    className?: string;
};

const StatusBadge = ({ className = '' }: Props) => {
    return (
        <StyledStatusBadge className={className}>
            <Text colorWhite h6>
                <FormattedMessage id="soldItemCarousel.badge" />
            </Text>
        </StyledStatusBadge>
    );
};

export default React.memo<Props>(StatusBadge);

const StyledStatusBadge = styled.div`
    position: absolute;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: 2px 8px;
    color: ${({ theme }) => theme.colors.white};
    margin: 7px 10px;
    top: 5px;
    left: 0;
    z-index: 2;
    background-color: ${({ theme }) => theme.colors.grey200};
    border-radius: 2px;
    text-transform: uppercase;

    @media (max-width: 767px) {
        margin: 18px 0 0 21px;
    }
`;
